import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search } from '@mui/icons-material';
import AllCustomers from '../../../component/allCustomers/AllCustomers';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import UserHeader from '../../../component/reusable/UserHeader';
import { styled } from '@mui/material/styles';
import TabHead from '../../../component/reusable/Tab';
import { exportCustomerThunk, getAllCustomerThunk, setCustomerPage } from '../../../redux/customer/customerSlice';
import { exportDataExcel, fomateDate } from '../../../utils/fomateDate';

const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    margin: "20px 0px",
    fontFamily: `'Public Sans', sans-serif`,
}));




function Customers() {

    const { customer, loading, error, refresh,exportLoading,page } = useSelector((state) => state.customer);

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [search, setSearch] = useState('')
    // const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [selectedTab, setSelectedTab] = useState(0);
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('asc')


    const customers = customer?.data
    const totalPages = customer?.totalPages
    const totalItems = customer?.totalItems
    const itemsPerPage = customer?.limit


    // calculate start & end of items -------------------
    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? "APPROVED" : selectedTab === 1 ? "PENDING" : "REJECTED"


    useEffect(() => {
        dispatch(getAllCustomerThunk(`?search=${search}&page=${page}&status=${status}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, limit, refresh, selectedTab,sortBy,order]);



    const handleChange = (event, newValue) => {
        dispatch(setCustomerPage(1))
        setSearch("")
        setSelectedTab(newValue);
    };


    const exportData = async () => {
        const statusss = `?status=${status}`
        const data = await dispatch(exportCustomerThunk(statusss))
        console.log(data);
        
        if (data?.payload?.success === true) {
            const customerData = data?.payload?.data
            const exportdata = customerData?.map((item) => ({
                'name': item?.fullName || '-',
                'phone': item?.phone,
                'email': item?.email || '',
                'gstn': item?.gstn || '',
                'status': item?.status || '-',
                'activeStatus': item?.activeStatus,
                'admin': item?.admin?.name,
                'createdAt': fomateDate(item?.createdAt),
            }))
            exportDataExcel(exportdata, "customer")
        }
    }

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

console.log(customer);

    return (
        <>
            <UserHeader
                index="Customers"
                root="Dashboard"
                onClickadd={() => navigate('/users/addCustomer')}
                buttonText={'Add Customer'}
                exportData={exportData}
                exportLoading={exportLoading}
            />
            <Box>

                <TabHead handleChange={handleChange} selectedTab={selectedTab} label={'All Customer'} />

                <Box mt={2}>
                    <SearchInput onChange={(e) => setSearch(e.target.value)}>
                        <IconButton aria-label="search">
                            <Search />
                        </IconButton>
                        <InputBase placeholder="Search…" />
                    </SearchInput>
                    {loading ?
                        <div>please wait...</div>
                        :
                        <>
                            {customers?.length > 0 ?
                                <>

                                    <Typography>
                                        <AllCustomers
                                            customers={customers}
                                            setPage={setCustomerPage}
                                            page={page}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            start={start}
                                            end={end}
                                            selectedTab={selectedTab}
                                            handleOpenMenu={handleOpenMenu}
                                        />
                                    </Typography>

                                </>
                                :
                                <div>
                                    no customers found
                                </div>
                            }
                        </>
                    }
                </Box>
            </Box>
        </>
    );
}

export default Customers;
